import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import T from "prop-types";
import { Field, formValueSelector } from "redux-form";
import {
  form,
  Form as AppForm,
  Select,
  Check,
  CheckGroup,
  FormInput,
  CurrencyField
} from "MODULES/shared/components/Forms";
import ShippingFields from "MODULES/Orders/shared/ShippingFields";
import * as actions from "MODULES/SalesOrders/actions";
import {
  CREDIT_REQUESTED,
  CUSTOMER_RMA_REASONS,
  FULL_CREDIT_REQUESTED,
  PARTIAL_CREDIT_AMT,
  PARTIAL_CREDIT_REQUESTED
} from "MODULES/RMAsAndWarranties/constants";
import { toOptions } from "LIB/forms";
import { Col } from "react-bootstrap";
import { REASON } from "MODULES/SalesOrders/constants";
import { properCase } from "LIB/formatters/text";
import { WARRANTY_CONSIDERATION } from "MODULES/RepairOrders/constants";
import {
  QUANTITY,
  RETURN_TO,
  RETURN_TO_COMPANY_ADDRESS_ID,
  RETURN_TO_COMPANY_ID,
  RETURN_TO_LOCATION_ID,
  RETURN_TO_SHIPPING_ADDRESS,
  RETURN_TO_SHIPPING_METHOD,
  RETURN_TO_TYPE,
  SUBTOTAL
} from "APP_ROOT/constants";
import { COMPANY, DROPSHIP } from "MODULES/PurchaseOrders/constants";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import { rounder } from "MODULES/shared/components/Forms/NumberInput/NumberInput";
import api from "APP_ROOT/api";
import { LocationFlag } from "MODULES/shared/components";
import { shortDateYY } from "LIB/formatters/date";
import { validate } from "./validate";
import FormRow from "../../../../../../shared/components/Forms/FormRow";

const FORM_NAME = "createCustomerRmaForm";

function Form(props) {
  const { lineItem } = props;
  const [inventory, setInventory] = useState(null);

  useEffect(
    () => {
      api.inventories
        .show(lineItem.inventory_id, "all", "rma_request")
        .then(({ data }) => {
          setInventory(data);

          return function cleanup() {};
        });
    },
    [lineItem.id]
  );

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={8}>
            <FormRow>
              <Col md={6}>
                <Field
                  name={REASON}
                  component={Select}
                  label={properCase(REASON)}
                  options={toOptions(CUSTOMER_RMA_REASONS)}
                  required
                />
              </Col>
            </FormRow>
            <FormRow>
              <Col md={3}>
                <CheckGroup justified title="WARRANTY CONSIDERATION?">
                  <Field
                    name={WARRANTY_CONSIDERATION}
                    component={Check}
                    label="Yes"
                  />
                </CheckGroup>
              </Col>
              <Col md={3}>
                <CheckGroup justified title={properCase(FULL_CREDIT_REQUESTED)}>
                  <Field
                    name={CREDIT_REQUESTED}
                    component={Check}
                    disabled={lineItem.exchange_sale && lineItem.received}
                    label="Full Credit"
                    onChange={(_, val) => {
                      if (val) {
                        props.setFieldValue(PARTIAL_CREDIT_REQUESTED)(false);
                      }
                    }}
                  />
                </CheckGroup>
              </Col>
              <Col md={3}>
                <CheckGroup justified title="Partial Credit Requested">
                  <Field
                    name={PARTIAL_CREDIT_REQUESTED}
                    disabled={lineItem.exchange_sale && lineItem.received}
                    component={Check}
                    label="Partial Credit"
                    onChange={(_, val) => {
                      if (val) {
                        props.setFieldValue(CREDIT_REQUESTED)(false);
                      }
                    }}
                  />
                </CheckGroup>
              </Col>
              {props.getFieldValue(PARTIAL_CREDIT_REQUESTED) && (
                <Col md={3}>
                  <CurrencyField
                    required
                    name={PARTIAL_CREDIT_AMT}
                    label="Partial Credit Amount"
                  />
                </Col>
              )}
              {props.getFieldValue(CREDIT_REQUESTED) && (
                <Col md={3}>
                  <label
                    className="control-label"
                    htmlFor={FULL_CREDIT_REQUESTED}
                  >
                    Full Credit Amount
                  </label>
                  <input
                    type="number"
                    disabled
                    className="form-control"
                    value={rounder(props.getInitialFieldValue(SUBTOTAL))}
                  />
                </Col>
              )}
            </FormRow>
          </Col>
          <Col md={4}>
            <div className="well">
              <h6 className="h4">Part Summary</h6>
              <table className="table table-condensed table-padding-horizonal-none margin-bottom-none">
                <tbody>
                  <tr>
                    <td>PN:</td>
                    <td className="text-right">
                      {get(lineItem, "part.part_number")}
                    </td>
                  </tr>
                  <tr>
                    <td>SN:</td>
                    <td className="text-right">{lineItem.serial_number}</td>
                  </tr>
                  <tr>
                    <td />
                    <td />
                  </tr>
                  <tr>
                    <td>Last Tagged By:</td>
                    <td className="text-right">
                      {get(inventory, "previous_tagged_by")}
                    </td>
                  </tr>
                  <tr>
                    <td>Last Tag Date:</td>
                    <td className="text-right">
                      {shortDateYY(get(inventory, "previous_tag_date"))}
                    </td>
                  </tr>
                  <tr>
                    <td>Store Owner:</td>
                    <td className="text-right">
                      {
                        <LocationFlag
                          location={lineItem.inventory.store_owner_id}
                        />
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Col>
        </FormRow>
        {Number(lineItem.quantity) > 1 && (
          <FormRow>
            <Col md={4}>
              <Field
                name={QUANTITY}
                label={properCase(QUANTITY)}
                component={FormInput}
              />
            </Col>
          </FormRow>
        )}
        {props.customerRmaReasons === "other" && (
          <FormRow>
            <Col md={6}>
              <Field
                name={"other_reason"}
                component={FormInput}
                label="Other-Reason"
                required
              />
            </Col>
          </FormRow>
        )}
        <div className="nav nav-tabs">
          <h4>Shipping Information</h4>
        </div>
        <FormRow>
          <Col md={12}>
            <ShippingFields
              formName={FORM_NAME}
              shippingFields={[
                RETURN_TO_TYPE,
                RETURN_TO_COMPANY_ID,
                RETURN_TO_COMPANY_ADDRESS_ID
              ]}
              shippingType={RETURN_TO}
              shippingTypes={[COMPANY, DROPSHIP]}
              enableReturnToType={false}
              shippingMethod={RETURN_TO_SHIPPING_METHOD}
              shippingAddressField={RETURN_TO_SHIPPING_ADDRESS}
              locationFieldName={RETURN_TO_LOCATION_ID}
              required={false}
              rmaRequestForm
            />
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

const selector = formValueSelector(FORM_NAME);

Form.propTypes = {
  props: T.shape({}).isRequired
};

export default connect(
  state => ({
    shippingType: selector(state, "shipping_type"),
    customerRmaReasons: selector(state, REASON)
  }),
  (dispatch, ownProps) => ({
    onSubmit: data =>
      dispatch(actions.createCustomerRma(ownProps.lineItem.id, data))
  })
)(
  form({
    form: FORM_NAME,
    validate
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/Detail/Body/LineItems/RmaRequest/Form.jsx